import react, { useEffect, useState } from "react";
import { Step, Stepper } from "@progress/kendo-react-layout";

// import { getProcessesStatusList } from "../../store/process/actions";
import { useDispatch, useSelector } from "react-redux";
import { getProcessesStatusList } from "../../../../store/process/actions";
// const items = [
// 	{
// 	  label: "Submitted",
// 	  //icon: "k-i-save",
// 	},
// 	{
// 	  label: "Cert Officer",

// 	  //icon: "k-i-signature",
// 	},
// 	{
// 	  label: "Appointing Auth",
// 	},
// 	{
// 	  label: "BBMR",
// 	},
// 	{
// 	  label: "Classification",// & Pay
// 	 // icon: "k-i-track-changes-accept",
// 	},
// 	  {
// 		label: "EMR",//Recruitment/Testing/
// 		//icon: "k-i-track-changes-accept",
// 	  },
// 	  {
// 		label: "Drug Testing",
// 		//icon: "k-i-track-changes-accept",
// 	  },
// 	  {
// 		label: "Records",
// 		//icon: "k-i-track-changes-accept",
// 	  },
// 	  {
// 		label: "Payroll",
// 		//icon: "k-i-track-changes-accept",
// 	  },
//   ];

const AnnouncementWorkflow = ({ currentValue, ProcessID, setRenderProcessFlow }) => {
  const {
    process,
    processStatusList,
    loadingProcessDetails,
    posting,
    postingResult,
    error,
  } = useSelector((state) => state.processReducer);
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [data, setData] = useState([]);
  const [processStatusesForGG1, setprocessStatusesForGG1] = useState([]);
  let dataRun = false;
  const handleChange = (e) => {
    // console.log("1212 stepper change ::: ", e, e.value, e.target.value);
    // setValue(e.value);
  };
  // useEffect(() => {
  //   if (currentValue) {
  //     setRenderProcessFlow(true);
  //   } else {
  //     setRenderProcessFlow(false);
  //   }
  // }, [currentValue]);
  useEffect(() => {
    if (ProcessID > 0 && currentValue) {
      dispatch(getProcessesStatusList(ProcessID));
    }
  }, [dispatch, ProcessID, currentValue]);
  useEffect(() => {
    if (processStatusList && processStatusList.length) {
      // let newArray = processStatusList.filter((item) => item.seq < 12);
      setData(
        processStatusList.map((d) => {
          return { label: d?.statusName };
        })
      );
      let stepIndex = processStatusList.indexOf(
        processStatusList.find((d) => d.id === currentValue)
      );
      setValue(stepIndex);
    }
  }, [processStatusList]);
  // useEffect(() => {
  //   if (processStatusesForGG1 && processStatusesForGG1.length > 0) {
  //     setData(
  //       processStatusesForGG1.map((d) => {
  //         return { label: d?.statusName };
  //       })
  //     );
  //     // setTimeout(() => {
  //     let stepIndex = processStatusesForGG1.indexOf(
  //       processStatusesForGG1.find((d) => d.id === currentValue)
  //     );
  //     setValue(stepIndex);
  //     // }, 1000);
  //   }
  // }, [processStatusesForGG1]);
  if (!data || data.length === 0) return null;
  return (
    <>
      <Stepper value={value} items={data} disabled />
    </>
  );
};
export default AnnouncementWorkflow;
